import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m10 2 2.069 5.152 5.54.376-4.261 3.56 1.354 5.384L10 13.52l-4.702 2.952 1.354-5.384-4.26-3.56 5.539-.376z"
    }, null, -1)
  ])))
}
export default { render: render }